// Module
var code = "<template>\n    <require from=\"./import-view\"></require>\n\n    <import-view scope.bind=\"scope\" customer.bind=\"customer\"></import-view>\n    <h2 resource=\"ImportContainer_SelectScopeFirst\" hide.bind=\"!!scope\"></h2>\n</template>\n";
// Exports
export default code;